module.exports = __webpack_public_path__ + "static/media/icon-drydoorunlocked.b4aeac21.svg";